const Reference = {
  geocodio: {    
    apiKey: 'c97708a9aca35579c0056b07cd7c58985b59bc7',
    geocodeUrl: 'https://api.geocod.io/v1.3/geocode',
  }
}

export default Reference;